export default class SchemaViewModel {
    id: number = 0;
    // The name of the schema
    name: string = '';
    // le nombre d'animaux sélectionnés dans ce code schéma
    nbrSelect : number = 0;
    // le nombre total de doses dans ce code schéma
    nbrDose: number = 0;
    // Le nombre total d'animaux dans ce code schéma présent sur le site
    nbrTotalAnimals: number = 0;
    nbrTotalCommercial:number = 0;
    nbrTotalDoseCommercial: number = 0;
    nbrArmada: number = 0;

    constructor(id: number, name: string, nbrSelect: number, nbrDose: number, nbrTotalAnimals: number, nbrTotalCommercial: number, nbrTotalDoseCommercial: number, nbrArmada: number) {
        this.id = id;
        this.name = name;
        this.nbrSelect = nbrSelect;
        this.nbrDose = nbrDose;
        this.nbrTotalAnimals = nbrTotalAnimals;
        this.nbrTotalCommercial = nbrTotalCommercial;
        this.nbrTotalDoseCommercial = nbrTotalDoseCommercial;
        this.nbrArmada = nbrArmada;
    }
}